import React, { useEffect, useState } from 'react';
import { useLayout } from '../../LayoutContext';
import { ParticipantsStyle } from './formsStyle';
import Header from '../../components/header/Header';
import cornerRightArrow from '../../components/assets/corner-right-down.svg';
import Logo from '../../components/assets/omint-pride.svg';
import imageSource from '../../components/assets/idades-do-plano-de-saude.webp';
import { useNavigate } from 'react-router-dom';
import ProgressBar from '../../components/status/ProgressBar';
import videoSource from '../../components/assets/Video_forms.mp4';
import FooterBack from '../../components/footer/FooterBack';

const FormParticipants = () => {
  const navigate = useNavigate();

  const [progress, setProgress] = useState(2);

  const { setLayoutConfig } = useLayout(); // Usa o hook para acessar a função de configuração

  useEffect(() => {
    // Configura a cor de fundo e o conteúdo do cabeçalho específicos para HomePage
    setLayoutConfig({
      backgroundColor: '#00022D',
      headerContent: {
        // Defina aqui os dados específicos do cabeçalho para a HomePage
      },
    });
  }, [setLayoutConfig]);

  const saveChoiceAndNavigate = (choice) => {
    // Salva a escolha no sessionStorage em formato JSON válido
    const choiceData = { choice };
    sessionStorage.setItem('@participantsChoice', JSON.stringify(choiceData));

    // Opções que devem redirecionar para /simulacao/4
    const optionsForSimulacao4 = [
      'Mais de 59 pessoas',
      '30 a 59 pessoas',
      '10 a 29 pessoas',
    ];

    // Verifica se a escolha está entre as opções para /simulacao/4
    const newPath = optionsForSimulacao4.includes(choice)
      ? '/simulacao/3'
      : '/simulacao/3';
    navigate('/simulacao/3');
  };

  const [isDropdownOpen, setIsDropdownOpen] = React.useState(false);

  // Função para alternar a visibilidade
  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  return (
    <>
      <ParticipantsStyle>
        <section className="formParticipants__wrapper">
          <div className="container col-12">
            <div className="logo-form">
              <img className="logo" src={Logo} alt="Logo" height={75} />
            </div>

            <div className="title__wrapper">
              <h1 className="title">
                Quantas pessoas vão participar do seu plano de saúde?
              </h1>

              <div className="question__wrapper">
                <p className="text" onClick={toggleDropdown}>
                  Por que essa pergunta?{' '}
                  <img
                    className={`arrow ${isDropdownOpen ? 'up' : ''}`}
                    src={cornerRightArrow}
                    alt="Saiba mais"
                  />
                </p>
                {/* Texto adicional que é mostrado/ocultado baseado no estado */}
                <p
                  className={`dropdown-content ${isDropdownOpen ? 'open' : ''}`}
                >
                  Para dimensionar cobertura e oferecer preços justos com base
                  no número de beneficiários.
                </p>
              </div>
            </div>

            <div className="buttons__wrapper">
              <button
                onClick={() => saveChoiceAndNavigate('1 a 5 pessoas')}
                className="button_link"
              >
                <p className="button_text">1 a 5 pessoas</p>
              </button>
              <button
                onClick={() => saveChoiceAndNavigate('6 a 9 pessoas')}
                className="button_link"
              >
                <p className="button_text">6 a 9 pessoas</p>
              </button>
              <button
                onClick={() => saveChoiceAndNavigate('10 a 29 pessoas')}
                className="button_link"
              >
                <p className="button_text">10 a 29 pessoas</p>
              </button>
              <button
                onClick={() => saveChoiceAndNavigate('30 a 59 pessoas')}
                className="button_link"
              >
                <p className="button_text">30 a 59 pessoas</p>
              </button>
              <button
                onClick={() => saveChoiceAndNavigate('Mais de 59 pessoas')}
                className="button_link"
              >
                <p className="button_text">Mais de 59 pessoas</p>
              </button>
            </div>
            <ProgressBar progress={progress} steps={5} />
          </div>
        </section>
        <FooterBack />
      </ParticipantsStyle>
    </>
  );
};

export default FormParticipants;
